require('./command.js');

(function(){
  PegasusTemplate.DeleteRowCommand = PegasusTemplate.Command.extend({
    klass: null,
    backup: null,
    sourceElement: null,
    callback: null,
    parent: null,
    childPosition: null,
    descriptionClass: 'deleted',
    description: function(){
      return Em.I18n.t('command_descriptions.deleted_row');
    }.property(),
    execute: function() {
      var parent = PegasusTemplate.blockRegionInstance,
        callback = this.get('callback'),
        child = parent.objectAt( this.get('childPosition') ),
        _super = this._super.bind(this);

      if ( callback ) {
        callback();
      }

      child.$().removeClass('make_transit').removeClass('bounce-in-right').removeClass('animated');

      PegasusTemplate.lookupController('historyOperations').setProperties({
        'controllers.blockOperations.content': null,
        'controllers.rowOperations.content': null
      });

      // allow 500ms for animation to complete
      Em.run.later( this, function(){
        parent.removeObject(child);
        _super();
      }, 500);

      child.$().addClass('bounce-out-left').addClass('animated').addClass('make_transit');
    },

    unexecute: function(callback){
      var parent = PegasusTemplate.blockRegionInstance,
        reborn = this.get('klass').create({
          container: parent.container,
          sourceElement: this.get('backup')
        }),
        _super = this._super.bind(this);

      parent.insertAt( this.get('childPosition'), reborn );

      Em.run.scheduleOnce( 'afterRender', reborn, function(){
        this.set('isVisible', true);
        this.$().addClass('bounce-in-right').addClass('animated').addClass('make_transit');
        _super();
      });
    }
  });
})();
